import { Component, Input, OnInit } from '@angular/core';

//* Core
import { PaystubInfo, UserContext } from '@core/models';
import { PaystubDetailsService, PaystubDownloadService, ScreenSizeService } from '@core/services';

//* Shared
import { BtnType, Icon } from '@shared/enums';
import { Dashboard } from '@dashboard/models';
import { fadeInOut } from '@shared/animations';
import { DashboardService } from '@dashboard/dashboard.service';

@Component({
  selector: 'sp-dashboard-details',
  templateUrl: `./dashboard-details.component.html`,
  styleUrls: ['./dashboard-details.component.scss'],
  animations: [fadeInOut],
})
export class DashboardDetailsComponent implements OnInit {
  paystubToDownload: PaystubInfo;
  //* Shared Enums
  btn = BtnType;
  icon = Icon;

  @Input() dashboard: Dashboard;
  @Input() userContext: UserContext;

  isMobile$ = this.screenSizeService.isMobile$;
  chartOptions$ = this.dashboardService.chartOptions$;

  constructor(
    private paystubDetailsService: PaystubDetailsService,
    private paystubDownloadService: PaystubDownloadService,
    private screenSizeService: ScreenSizeService,
    private dashboardService: DashboardService
  ) {}
  ngOnInit() {
    this.paystubToDownload = this.dashboard.paystubInfos[0];
  }

  //* PaystubInfo => Checks => PaystubInfo
  downloadPaystub(): void {
    this.paystubDownloadService.download({ ...this.paystubToDownload });
  }

  changePaystub(paystubId: string): void {
    const paystub = this.getCurrentCheck(this.dashboard.paystubInfos, paystubId);

    this.setDataForDownload(paystub);
    this.paystubDetailsService.getPaystubDetail(paystub);
  }

  getCurrentCheck(paystubs: PaystubInfo[], paystubId: string): PaystubInfo {
    return paystubs.filter(selectedCheck => selectedCheck.checkId === paystubId)[0];
  }

  getPaystubToDownload(paystubInfos: PaystubInfo[]): PaystubInfo {
    return this.paystubToDownload ? this.paystubToDownload : paystubInfos[0];
  }

  setDataForDownload(paystubInfo: PaystubInfo): void {
    const { amount, checkId, didId, day } = paystubInfo;
    this.paystubToDownload = { amount: amount.toString(), checkId, didId, day };
  }
}
